import { CurrencyPipe, DecimalPipe, Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Referential } from 'src/app/models/referential';
import { ServiceResponse } from 'src/app/models/service-response';
import { CustomersService } from 'src/app/rest_services/customers.service';
import { ProductCategoryService } from 'src/app/rest_services/family.service';
import { MsSectorService } from 'src/app/rest_services/ms-sector.service';
import { SalesService } from 'src/app/rest_services/sales.service';
import { SettingsService } from 'src/app/rest_services/settings.service';
import { exportToExcelSimple } from 'src/app/rest_services/utilFunctions/generateExcels';
import { VisitService } from 'src/app/rest_services/visit.service';
import { VisitsService } from 'src/app/rest_services/visits.service';


import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css']
})
export class CustomerComponent implements OnInit {
  loading_tab_details:boolean=true;
  uuid:any;
  fromUuidVisit:any;
  role:any=null;comp:any=null;
  mobile:boolean=false;medium:boolean=false;
  token:any = '';
  categoriesSubscription!:Subscription;
  salesSubscription!:Subscription;

  grandTotalHT:  number = 0;
  grandTotalTTC: number = 0;
  
  constructor(
    private customersService :CustomersService,
    private visitService: VisitsService,
    private salesService: SalesService,
    private route: ActivatedRoute,
    private router: Router,
    private settingsService:SettingsService,
    private msSector:MsSectorService, 
    private location : Location,
    private fb: FormBuilder,
    private productCategoryService: ProductCategoryService
  ) { }
  previousUrl:any;
  id:any;
  roles :any[] =[];
  currentYear: any="0";
  caCustomerLoading:boolean=true;
  newSaleForm!:FormGroup;
  filterYearForm!:FormGroup;
  commercialId:any = null;
  originRedirecion:any="customers";

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear().toString();
    // $("#yearsSelect").val(this.currentYear)
    if(localStorage.getItem("userRoles")!=undefined) {
      this.roles = JSON.parse(localStorage.getItem('userRoles') || '[]');
    }else if(sessionStorage.getItem("userRoles")!=undefined){
      this.roles = JSON.parse(sessionStorage.getItem('userRoles') || '[]');
    }
    this.getConfig();
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    let decodedJWT = JSON.parse(window.atob(this.token.split('.')[1]));
    this.commercialId = decodedJWT.user_uuid;
    
    var fr= window.location.href.split( 'from');
    if(fr[1]!=undefined && fr.length>0){
      var from = fr[1].split(';')[0];
      this.id= this.route.snapshot.paramMap.get('cr')
      setTimeout(()=>{
        if(from=="show"){
          (<any>$('.nav-pills a[href="#border-top-detail"]')).tab('show');
          // (<any>$('.nav-pills a[href="#conversation"]')).tab('show');
          // this.getTabProfiles();
        } 
        if(from=="notif"){
          // (<any>$('.nav-tabs a[href="#conversation"]')).tab('show');
          (<any>$('.nav-pills a[href="#conversation"]')).tab('show');
          this.getConversationAboutCustomer(this.uuid)
          // this.getTabUsers();
        }
        if(from=="Ref"){
          (<any>$('.nav-pills a[href="#border-top-detail"]')).tab('show');
          this.originRedirecion = "referentiel";
        }
      }, 1000);
      
    }
    this.uuid = this.route.snapshot.params['cs'];
    this.fromUuidVisit = this.route.snapshot.params['vs'];
    this.previousUrl = sessionStorage.getItem('previousUrl');
    this.retrieveCustomer(this.uuid);
    if(localStorage.getItem("role")!=undefined) {
      this.role =localStorage.getItem("role");
      this.comp=localStorage.getItem("comp");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role =sessionStorage.getItem("role");
      this.comp=sessionStorage.getItem("comp");
    }
    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
      if (window.screen.width > 668) this.medium = true;
    }else {
      this.mobile = false;
    }
    this.newSaleForm = this.fb.group({
      visit     : [''],
      reference : [''],
      saleLines : this.fb.array([]),
    });
    this.addSaleLine(); // première ligne vide
      this.filterYearForm = this.fb.group({
          'ca_year': [this.years[0]],
        });
      this.getCategories();
      this.getResumVisitSrc();
      this.getSalesCustomer(this.currentYear);
  }

  //#region SALE MANAGEMENT
    // ── Accesseur FormArray ──────────────────────────────────────
    get saleLinesArray(): FormArray {
      return this.newSaleForm.get('saleLines') as FormArray;
    }

    // ── Créer un groupe de contrôles pour une ligne ──────────────
    private createSaleLine(): FormGroup {
      return this.fb.group({
        category   : ['', Validators.required],
        description: ['', Validators.required],
        unit_price : [null, [Validators.required, Validators.min(0)]],
        qte        : [null, [Validators.required, Validators.min(0.001)]],
        taxe_value : [20,   [Validators.required, Validators.min(0)]],
        totalHT    : [{ value: 0, disabled: true }],
        totalTTC   : [{ value: 0, disabled: true }],
      });
    }

    // ── Ajouter une ligne ────────────────────────────────────────
    addSaleLine(): void {
      this.animatePreviousRow();
      this.saleLinesArray.push(this.createSaleLine());
    }
    private animatePreviousRow(): void {
      if (this.saleLinesArray.length === 0) return;

      const rows = document.querySelectorAll('.sl-row');
      const lastRow = rows[rows.length - 1] as HTMLElement;
      if (!lastRow) return;

      lastRow.classList.remove('sl-row-validated'); // reset si déjà appliqué
      void lastRow.offsetWidth;                      // force reflow pour re-déclencher
      lastRow.classList.add('sl-row-validated');
    }

    // ── Supprimer une ligne (confirmation si données présentes) ──
    pendingDeleteIndex: number | null = null;

    removeSaleLine(index: number): void {
      const line    = this.saleLinesArray.at(index) as FormGroup;
      const hasData = line.get('description')?.value
                  || line.get('unit_price')?.value
                  || line.get('qte')?.value;

      if (hasData) {
        this.pendingDeleteIndex = index;
        (<any>$('#confirmDeleteLineModal')).modal('show');
      } else {
        // Ligne vide → suppression directe sans confirmation
        this.saleLinesArray.removeAt(index);
        this.recalculateGrandTotals();
      }
    }

    confirmDeleteLine(): void {
      if (this.pendingDeleteIndex !== null) {
        this.saleLinesArray.removeAt(this.pendingDeleteIndex);
        this.recalculateGrandTotals();
        this.pendingDeleteIndex = null;
      }
      (<any>$('#confirmDeleteLineModal')).modal('hide');
    }

    // ── Recalcul totaux d'une ligne ──────────────────────────────
    calculateLineTotals(index: number): void {
      const line      = this.saleLinesArray.at(index) as FormGroup;
      const unitPrice = parseFloat(line.get('unit_price')?.value) || 0;
      const qte       = parseFloat(line.get('qte')?.value)        || 0;
      const tva       = parseFloat(line.get('taxe_value')?.value) || 0;

      const ht  = this.roundToTwo(unitPrice * qte);
      const ttc = this.roundToTwo(ht * (1 + tva / 100));

      line.patchValue({ totalHT: ht, totalTTC: ttc }, { emitEvent: false });
      this.recalculateGrandTotals();
    }

    // ── Recalcul totaux globaux ──────────────────────────────────
    recalculateGrandTotals(): void {
      this.grandTotalHT  = 0;
      this.grandTotalTTC = 0;
      this.saleLinesArray.controls.forEach((ctrl: AbstractControl) => {
        const g = ctrl as FormGroup;
        this.grandTotalHT  += parseFloat(g.get('totalHT')?.value)  || 0;
        this.grandTotalTTC += parseFloat(g.get('totalTTC')?.value) || 0;
      });
      this.grandTotalHT  = this.roundToTwo(this.grandTotalHT);
      this.grandTotalTTC = this.roundToTwo(this.grandTotalTTC);
    }
    private resetForm(): void {
        this.saleLinesArray.clear();
        this.newSaleForm.reset({ visit: '', reference: '' });
        this.grandTotalHT  = 0;
        this.grandTotalTTC = 0;
        this.addSaleLine(); // repart avec une ligne vide
      }
  //#endregion

  //#region ACTIONS & OPERATIONS
  hasRole(role: string): boolean {    
    return this.roles.includes(role);
  }

  config: any = {
    skypeVisibility: false,
    zipCodeVisibility: false
  };
  getConfig(){
    this.settingsService.getConfig().subscribe(
      (resp: any) => {
        if(resp.code == "45859d1ba9e878f62c51935e3119d7ad"){
          this.config.skypeVisibility = resp.config.skypeVisibility;
          this.config.zipCodeVisibility = resp.config.zipCodeVisibility;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  previousPage() {
    if (this.previousUrl && this.previousUrl.includes('/edit-customer/')) {
      if (this.role === 'adm' || this.role === 'asst') {
        this.router.navigate(['/customers/show', { cs: 'all' }]);
      } else if (this.role === 'cmrc') {
        this.router.navigate(['/my-customers/show', { cs: 'all' }]);
      }
      sessionStorage.removeItem('previousUrl');
    } else {
      this.location.back();
    }
  }

  calculateTotalHTFromSales(): number {
    let totalHT = 0;
    if (this.salesData && this.salesData.length > 0) {
      this.salesData.forEach(sale => {
        if (!sale.isMonthHeader && sale.totalHt) {
          totalHT += sale.totalHt;
        }
      });
    }
    return totalHT;
  }

  hasSales(): boolean {
    if (!this.salesData || this.salesData.length === 0) {
      return false;
    }
    
    return this.salesData.some(sale => !sale.isMonthHeader);
  }
  // In your component.ts file
  hasServices(): boolean {
    // Check if selectedCustomer exists and has at least one service
    return (
      this.selectedCustomer &&
      this.selectedCustomer.customer_sites &&
      this.selectedCustomer.customer_sites.length > 0 &&
      this.selectedCustomer.customer_sites.some(
        (site: any) =>
          site.customerService && site.customerService.length > 0
      )
    );
  }

  checkAddress(address: string): string {
    if (address !== null && address !== undefined && address.trim() !== '') {
      return address.trim();
    } else {
      return '----';
    }
  } 
  checkServices(customerService: any): string {
    if (customerService !== null && customerService !== undefined && customerService.length > 0) {
      return customerService[0].service_name.trim();
    } else {
      return '----';
    }
  }

  selectedCustomer:any=null;
  retrieveCustomerSubscription!:Subscription;
  retrieveCustomerLoder:boolean = false;
  showSalesBlocs:boolean = false;
  financialNumbers:any ={};
  CAsNotDefined:boolean = true;
  affectedToMe:boolean = false;
  retrieveCustomer(customer:any){
    this.retrieveCustomerLoder = true;
    this.selectedCustomer = null;
    this.retrieveCustomerSubscription=this.customersService.retrieveCustomer(customer,this.currentYear.toString()).subscribe(
      (data:any) => {
        if (data.code == "91cb649c3775dae97f5a003ced0791b9"){
          if(data.customer.commercials.length>0){
            if(data.customer.commercials[data.customer.commercials.length-1].commercial_uuid == this.commercialId 
              || data.customer.added_by_me){
              this.showSalesBlocs=true;
            }else {
              this.showSalesBlocs=false;
            }
          }else {
            this.showSalesBlocs=false;
          }
          if(data.customer.commercials[data.customer.commercials.length-1]?.commercial_uuid == this.commercialId){
            this.affectedToMe = true;
          }else {
            this.affectedToMe = false;
          }          
          this.selectedCustomer = data.customer; 
          if(data.customer?.annualCAc.length==0){
            data.customer?.annualCAc.push({
              "year":this.currentYear.toString(),
              "realized":0,
              "goal":0,
              "potential":0
            })
          }else {
            this.CAsNotDefined = false;
          }
          this.financialNumbers.year = this.currentYear;
          // this.financialNumbers = data.customer?.annualCAc[0];  
          // if (this.financialNumbers && 
          //     (this.financialNumbers.year === "null" || this.financialNumbers.year === null)) {
          //   this.financialNumbers.year = this.currentYear;
          // }
          this.generateYearsWithCurrent();
          this.filterYearForm.get('ca_year')?.setValue(this.currentYear);     
          this.msSector.getSector(this.token,this.selectedCustomer.sector).subscribe(
            (sectorLabel: any) => {
              this.selectedCustomer.customer_sector = sectorLabel.label;
            },
            (error) => {
              console.log(error);
            }
          );
          this.loading_tab_details=false;
          this.hasServices();
           // Check if the customer has a logo
           if (this.selectedCustomer.customer_logo) {
            // Convert the base64 logo to a data URL
            const logoDataUrl = 'data:image/*;base64,' + this.selectedCustomer.customer_logo;
            const imageDiv = document.getElementById('logo');
            if (imageDiv) {
              // Create an <img> element and set its src attribute
              const imgElement = document.createElement('img');
              imgElement.src = logoDataUrl;
              imgElement.alt = 'Customer Logo';
              imgElement.style.marginRight= "9px";
              imgElement.style.marginBottom= "20px";
              imgElement.style.width = '65px';
              imgElement.style.height = '65px';
              imgElement.style.borderRadius= "50%";
              imgElement.style.border = 'solid 5px #bad0c9';
              imageDiv.innerHTML = '';
              imageDiv.appendChild(imgElement);
            }
          }
        }
        this.retrieveCustomerLoder = false;
        this.caCustomerLoading = false;
      },
      (error: any) => {
        console.log(error);
        this.retrieveCustomerLoder = false;
        this.caCustomerLoading = false;
      }
    );
    //this.getConversationAboutCustomer(customer);
  }
  refreshDetails(){
    this.retrieveCustomerSubscription=this.customersService.retrieveCustomer(this.uuid,this.currentYear.toString()).subscribe(
      (data:any) => {
        if (data.code == "91cb649c3775dae97f5a003ced0791b9"){
          this.selectedCustomer = data.customer;
          if(data.customer.commercials.length>0){
            if(data.customer.commercials[0].commercial_uuid == this.commercialId 
              || data.customer.added_by_me){
              this.showSalesBlocs=true;
            }else {
              this.showSalesBlocs=false;
            }
          }else {
            this.showSalesBlocs=false;
          }
          this.filterYearForm.get('ca_year')?.setValue(this.currentYear);  
        }
        this.retrieveCustomerLoder = false;
        this.caCustomerLoading = false;
      },
      (error: any) => {
        console.log(error);
        this.retrieveCustomerLoder = false;
        this.caCustomerLoading = false;
      }
    );
  }

  loadingMessages:boolean=false;
  messages:any[]=[];
  getConversationAboutCustomer(customerUuid:string){
    this.messages = [];
    this.loadingMessages=true;
    this.customersService.getCustomerConversation(customerUuid).subscribe(
      ( data: any ) => {        
        if(data.code=="a06f376e86f9c47135aee1d1bac7b3e3") {
          this.messages = data.messagesVisit;
          //$(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0]?.scrollHeight }, 200)

          setTimeout(() => {  
            $(".chat-messages")[0]?.animate({ scrollBottom: "320px" }, 200)
            var objDiv = $(".chat-messages")[0];
            objDiv.scrollTop = objDiv?.scrollHeight;
           }, 1000); 
        }
        this.loadingMessages=false;
      },
      error => {
        console.error('There was an error!', error);
      }
    )
  }
  sending: boolean = false;
  sendNewMessage(customerUuid:string){
    var message = $('#messageText').val();
    var myImage = null;
    var myavatar = this.messages.find((d:any) => d.sender== "me");
    if(myavatar!=undefined && myavatar!=null){
      myImage = myavatar.sender_avatar;
    }else {
      myImage = null;
    }            
    if(message != null && message != ""){
      this.sending = true;
      var newMessage = {
        message:message,
        sent_at:new Date(),
        sender:"me",
        sender_avatar:myImage,
        important:$("#roundedChk2").is(':checked')
      }
      var requestBody = {
        message:message,
        important:$("#roundedChk2").is(':checked')
      }
      this.customersService.sendMessage(customerUuid, requestBody).subscribe(
        ( data: any ) => {
          if(data.code=="2ea8e5510c04f55b90c85304f9f59532") {
            $('#messageText').val("");
            this.messages.push(newMessage);
            // $(".chat-messages").animate({scrollTop:$(".chat-messages")[0].scrollHeight})
            $(".chat-messages").animate({ scrollTop: $(".chat-messages")[0]?.scrollHeight }, 500)
            $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0]?.scrollHeight }, 200)
          }
          this.loadingMessages=false;
          this.sending = false;
        },
        error => {
          console.error('There was an error!', error);
        }
      );
    }
    
  }

  customerArchiveRequest:any={};
  loadingArchiveCustomer:boolean=false;
  archiveCustomer(){
    this.loadingArchiveCustomer = true;
    this.customersService.archiveCustomer(this.uuid);
    this.customerArchiveRequest=this.customersService.archiveCustomerSubject.subscribe(
      ( data: any ) => {
        if(data.code=="e5b99f09c7461ee9de1537ddcfd1c638"){
          this.loadingArchiveCustomer = false;
          this.selectedCustomer.archived=true;
          this.selectedCustomer.archivedBy = data.archivedBy;
          this.selectedCustomer.archivedAt = data.archivedAt;
          $("#customer_archived").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            });
            $("#customer_archived").hide();
          }, 8000);
        }else if(data.code=="587df0508983999872819f4041aef551"){
          this.loadingArchiveCustomer = false;
          $("#customer_not_archived").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            });
            $("#customer_not_archived").show();
          }, 8000);
        }else {
          this.loadingArchiveCustomer = false;
          $("#customer_not_archived").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            });
            $("#customer_not_archived").hide();
          }, 8000);
        }
        window.scroll({ 
          top: 0, 
          left: 0, 
          behavior: 'smooth' 
        });
      },
    )
  }
  //#endregion

  //#region SALES MANAGEMENT
  years: any[] = [];
  
  generateYearsWithCurrent(): void {
    const currentYear = new Date().getFullYear();
    for (let i = 0; i <= 4; i++) {
      const year = currentYear + i;
      const yearStr = year.toString();
      const financialYear = this.financialNumbers?.year;

      if (yearStr === this.currentYear) {
        this.years.push({
          value: yearStr,
          text: yearStr,
          disabled: false,
          selected: true
        });
      } else if (yearStr === financialYear || year === Number(financialYear) + 1) {
        this.years.push({
          value: yearStr,
          text: yearStr,
          disabled: false,
          selected: false
        });
      } else {
        this.years.push({
          value: yearStr,
          text: yearStr,
          disabled: true
        });
      }
    }
  }
  categories: Array<Referential> = [];
  categoriesFiltered: Array<Referential> = [];
  getCategories(){
      this.categoriesSubscription = this.productCategoryService.getProductCategories().subscribe(
        (data: ServiceResponse) => {   
          if(data.code == "cf0e0d96d99d8cd08b9f74c6dd7c1bb8"){          
            this.categories = data.categories?data.categories:[];          
            this.categoriesFiltered = this.categories
            .filter((item) => item.category !== undefined) // Filter out elements with undefined topic
            .sort((a, b) => {
              if (a.category && b.category) {
                return a.category.localeCompare(b.category);
              } else if (a.category) {
                return -1;
              } else {
                return 1;
              }
            });
          }
          // this.categoriesLoader=false;         
        },
        (error) => {
          console.log(error);
          // this.categoriesLoader=false;   
        }
      );
    }
      visitsSrc:any[]=[];
      currentVisit:any;
      hideVisitField:boolean= false;
      getResumVisitSrc(){
        var uuidVisit = this.route.snapshot.params['vs'];
        if(uuidVisit!=null && uuidVisit!="" && uuidVisit!=undefined){
          this.hideVisitField = false;
        }else {
          this.hideVisitField = true;
        }
        this.visitService.getVisitToSale(uuidVisit);
        this.visitService.visitToSaleSubject.subscribe(
          ( data: any ) => {
            if(data.code =="9ee6b80261f5935fcdc9848ac558b605"){
              this.currentVisit= data.visitToSale;
              this.visitsSrc.push(this.currentVisit);
              this.newSaleForm.get('visit')?.setValue(this.currentVisit.uuid);
            }
          },
        )  
      }

      /**
   * Configurer le calcul automatique
   */
  private setupAutoCalculation(): void {
    // Écouter les changements sur les champs qui affectent le calcul
    this.newSaleForm.get('unit_price')?.valueChanges.subscribe(() => {
      this.calculateTotals();
    });

    this.newSaleForm.get('qte')?.valueChanges.subscribe(() => {
      this.calculateTotals();
    });

    this.newSaleForm.get('taxe_value')?.valueChanges.subscribe(() => {
      this.calculateTotals();
    });
  }

  /**
   * Calculer les totaux HT et TTC
   */
  totalHT: number = 0;
  totalTTC: number = 0;
  calculateTotals(): void {
    const unitPrice = this.parseNumber(this.newSaleForm.get('unit_price')?.value);
    const quantity = this.parseNumber(this.newSaleForm.get('qte')?.value);
    const tva = this.parseNumber(this.newSaleForm.get('taxe_value')?.value);

    // Calculer Total HT = Prix unitaire × Quantité
    this.totalHT = unitPrice * quantity;

    // Calculer Total TTC = Total HT + (Total HT × TVA / 100)
    const montantTVA = this.totalHT * (tva / 100);
    this.totalTTC = this.totalHT + montantTVA;

    // Arrondir à 2 décimales
    this.totalHT = this.roundToTwo(this.totalHT);
    this.totalTTC = this.roundToTwo(this.totalTTC);    
  }

  /**
   * Parser un nombre de manière sûre
   */
  private parseNumber(value: any): number {
    if (value === null || value === undefined || value === '') {
      return 0;
    }
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }

  /**
   * Arrondir à 2 décimales
   */
  private roundToTwo(num: number): number {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  /**
   * Formater un nombre pour l'affichage
   */
  formatNumber(value: number): string {
    if (value === 0 || value == null) return '0.00';
    return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  /**
   * Soumettre le formulaire
   */
  onSubmit(): void {
    if (this.newSaleForm.valid) {
      const formData = {
        ...this.newSaleForm.value,
        totalHT: this.totalHT,
        totalTTC: this.totalTTC
      };
    } else {
      this.markFormGroupTouched(this.newSaleForm);
    }
  }

  /**
   * Marquer tous les champs comme touchés pour afficher les erreurs
   */
  private markFormGroupTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      control?.markAsTouched();
    });
  }

  processToSave(param:any){
    // Déclenche la validation Angular sur tous les champs
    this.newSaleForm.markAllAsTouched();

    if (this.newSaleForm.invalid || this.saleLinesArray.length === 0) {
      return;
    }
    var valuesSaleForm = this.newSaleForm.value;
    if(param=="save"){
      if(this.fromUuidVisit!=undefined && this.fromUuidVisit!="" && this.fromUuidVisit!=null 
          && (valuesSaleForm.visit == null || valuesSaleForm.visit == undefined || valuesSaleForm.visit == "")){
        // (<any>$('#saleWithoutVisitCustomer')).modal('show');
        // this.btn_type = "save"
      }else {
        this.newSale("keep");
      }
    }else {
      if(this.fromUuidVisit!=undefined && this.fromUuidVisit!="" && this.fromUuidVisit!=null 
          && (valuesSaleForm.visit == null || valuesSaleForm.visit == undefined || valuesSaleForm.visit == "")){
        (<any>$('#saleWithoutVisitCustomer')).modal('show');
        this.btn_type = "saveReturn"
      }else {
        this.newSale("return");
      }
    }
  }
  saleSaved:boolean=false;
  saleSaveFailed:boolean=false;
  loadingSaveSale:boolean=false;
  newSaleRequest:any={};
  btn_type:any;
  newSale(action:any){
    (<any>$('#saleWithoutVisitCustomer')).modal('hide');
    var valuesSaleForm = this.newSaleForm.value;
    this.loadingSaveSale = true;
    if(this.newSaleForm.valid){  
      this.newSaleRequest = {
        visit     : valuesSaleForm.visit,
        reference : valuesSaleForm.reference,   // ← nouveau
        customer  : this.uuid,
        totalHt  : this.grandTotalHT,          // ← nouveau
        totalTtc : this.grandTotalTTC,         // ← nouveau
        lines     : (this.newSaleForm.getRawValue().saleLines as any[]).map((l: any) => ({
          productCategory : l.category,
          designation     : l.description,
          unitPrice       : l.unit_price,
          quantity        : l.qte,
          tva             : l.taxe_value
        })),
      };
      this.salesService.newSaleRequest = this.newSaleRequest;
      this.salesService.newSale();
      this.newSaleRequest=this.salesService.newSaleSubject.subscribe(
        ( data: any ) => {
          var idVisitSent;
          if(valuesSaleForm.visit!="" && valuesSaleForm.visit!=null && valuesSaleForm.visit!=undefined){
            idVisitSent = true;
          }else {
            idVisitSent=false;
          }
          this.getSalesCustomer(this.currentYear);
          if(data.code=="ca98dc433757a8dc5fc69c62fbac970e"){
            
            this.saleLinesArray.clear();
            this.addSaleLine();
            this.saleSaved = true;
            this.saleSaveFailed = false;
            this.refreshDetails();
            this.newSaleForm.reset({
              visit    : idVisitSent ? this.currentVisit.uuid : '',
              reference: ''
            });

            // Réinitialiser la TVA sur la nouvelle ligne (index 0)
            this.saleLinesArray.at(0)?.get('taxe_value')?.setValue(20);

            // Réinitialiser la famille sur la nouvelle ligne (index 0)
            this.saleLinesArray.at(0)?.get('category')?.setValue('');
            setTimeout(()=>{
              this.saleSaved = false;
            }, 8000);
            if(action=="return" || this.btn_type == "saveReturn"){
              setTimeout(()=>{
                const url = `/complete-visit/fromComplete;cr=${this.fromUuidVisit}`;
                this.router.navigateByUrl(url);
              }, 2000);
            }
            //this.newSaleForm.reset();
            // this.newSaleForm.get('taxe_value')!.setValue('20');
            if(idVisitSent){
              this.newSaleForm.get('visit')?.setValue(this.currentVisit.uuid);
            }else {
              this.newSaleForm.get('visit')?.setValue("");
            }
            // this.newSaleForm.get('category')?.setValue("");
            this.grandTotalHT=0;
            this.grandTotalTTC=0;
            $('#totalHT').val(0);
            $('#tttc').val(0);
          }else {
            this.saleSaved = false;
            this.saleSaveFailed = true;
            setTimeout(()=>{
              this.saleSaveFailed = false;
            }, 8000);
          }
          this.loadingSaveSale = false;
        })
    }
  }
  salesData: any[] = [];
  loadingListSales:boolean =false;
  getSalesCustomer(year:any){
    this.loadingListSales = true;    
    if(year!=null){
      this.currentYear = year;
    }
    this.salesSubscription = this.salesService.getSalesOfCustomerByYear(this.currentYear,this.uuid).subscribe(
      (data: any) => {    
        this.salesData = data.sales;
        this.salesDataFiltred = data.sales
        this.financialNumbers.goal = data.summary.totalGoalYear;
        this.financialNumbers.potential = data.summary.totalPotentialYear;
        this.loadingListSales = false    
        if(data.code == "cf0e0d96d99d8cd08b9f74c6dd7c1bb8"){          
          this.loadingListSales = false
        }       
        // this.initializeDataTable();
      },
      (error) => {
        console.log(error);
        this.loadingListSales = false  
      }
    );
  }

  @ViewChild('salesTable', { static: false }) salesTable!: ElementRef;
  dataTable: any;
  
  loading: boolean = true;
  initializeDataTable(): void {
    // Attendre que le DOM soit prêt
    // this.dataTable =  (<any>$('#salesTable')).DataTable({ /* options */ });
    setTimeout(() => {
      this.dataTable = (<any>$('#salesTable')).DataTable({
        "pagingType": "full_numbers",
        "scrollX": '400px',
        "scrollCollapse": true,
        "aaSorting": [],
        "iDisplayLength": 25,
        "language": {
          "sProcessing": "Traitement en cours ...",
          "sLengthMenu": "Afficher _MENU_ lignes",
          "sZeroRecords": "Aucun résultat trouvé",
          "sEmptyTable": "Aucune donnée disponible",
          "sInfo": "",
          "sInfoEmpty": "",
          searchPlaceholder: "Saisir un mot clé",
          "sInfoFiltered": "",
          "sInfoPostFix": "",
          "sSearch": "Rechercher:",
          "sUrl": "",
          "sInfoThousands": ",",
          "sLoadingRecords": "Chargement...",
          "oPaginate": {
            "sFirst": "<i class='flaticon-left-arrow'></i>", 
            "sLast": "<i class='flaticon-right-arrow'></i>", 
            "sNext": "<i class='flaticon-arrow-right'></i>", 
            "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
          },
          "oAria": {
            "sSortAscending": ": Trier par ordre croissant", 
            "sSortDescending": ": Trier par ordre décroissant"
          }
        },
        data: this.salesData,
        columns: [
          { 
            data: 'saleRef',
            title: 'Ref Vente',
            render: (data: string, type: string, row: any) => {
              return row.isMonthHeader ? '' : (data || '');
            }
          },
          { 
            data: 'designation',
            title: 'Désignation',
            render: (data: string, type: string, row: any) => {
              if (row.isMonthHeader) {
                return `<strong style="color: #333; font-size: 14px;">${data}</strong>`;
              }
              return data || '';
            }
          },
          { 
            data: 'famille',
            title: 'Famille',
            render: (data: string, type: string, row: any) => {
              return row.isMonthHeader ? '' : (data || '');
            }
          },
          { 
            data: 'prixUnitaire',
            title: 'Prix unitaire',
            className: 'text-right',
            render: (data: number, type: string, row: any) => {
              if (row.isMonthHeader) return '';
              return data ? data.toFixed(2) : '';
            }
          },
          { 
            data: 'quantite',
            title: 'Quantité',
            className: 'text-center',
            render: (data: number, type: string, row: any) => {
              return row.isMonthHeader ? '' : (data || '');
            }
          },
          { 
            data: 'totalHt',
            title: 'Total HT',
            className: 'text-right',
            render: (data: number, type: string, row: any) => {
              if (row.isMonthHeader) return '';
              return data ? data.toFixed(2) : '';
            }
          },
          { 
            data: 'tva',
            title: 'TVA',
            className: 'text-right',
            render: (data: number, type: string, row: any) => {
              if (row.isMonthHeader) return '';
              return data ? data.toFixed(2) : '';
            }
          },
          { 
            data: 'totalTtc',
            title: 'Total TTC',
            className: 'text-right',
            render: (data: number, type: string, row: any) => {
              if (row.isMonthHeader) {
                const total = row.monthTotal || 0;
                const color = total < 0 ? 'red' : 'green';
                return `<strong style="color: ${color};">${total.toFixed(2)} MAD</strong>`;
              }
              return data ? data.toFixed(2) : '';
            }
          },
          { 
            data: 'faitePar',
            title: 'Faite par',
            render: (data: string, type: string, row: any) => {
              return row.isMonthHeader ? '' : (data || '');
            }
          },
          { 
            data: 'origine',
            title: 'Origine',
            render: (data: string, type: string, row: any) => {
              if (row.isMonthHeader) return '';
              if (data && data !== '---') {
                return `<a href="/sales/${data}" class="text-primary">${data}</a>`;
              }
              return '---';
            }
          }
        ],
        order: [[0, 'asc']], // Tri par défaut
        dom: 'Blfrtip', // Boutons, longueur, filtre, tableau, infos, pagination
    
        // Options de pagination
        pageLength: 25, // Nombre d'éléments par page par défaut
        lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "Tous"]],
        
        // Options de recherche
        searchHighlight: true,
        buttons: [
        {
          extend: 'excelHtml5',
          title: 'Ventes par mois',
          text: '<i class="fas fa-file-excel"></i> Excel',
          className: 'btn btn-success',
          exportOptions: {
            columns: ':visible',
            modifier: {
              page: 'current' // 'current', 'all', ou 'selected'
            }
          }
        }],
        rowCallback: (row: Node, data: any) => {
          // Styliser les lignes d'en-tête de mois
          if (data.isMonthHeader) {
            $(row).css({
              'background-color': '#f8f9fa',
              'font-weight': 'bold',
              'border-top': '2px solid #dee2e6',
              'border-bottom': '2px solid #dee2e6'
            });
          } else {
            // Alterner les couleurs pour les lignes normales
            $(row).addClass(data.monthOrder! % 2 === 0 ? 'even-month' : 'odd-month');
          }
        },
        // Grouper par mois
        drawCallback: (settings: any) => {
          const api = this.dataTable;
          const rows = api.rows({ page: 'current' }).nodes();
          let last: string | null = null;
          
          api.column(0, { page: 'current' }).data().each((group: string, i: number) => {
            const rowData = this.salesData[settings.json ? settings.json.recordsTotal : i];
            
            if (rowData && rowData.isMonthHeader && last !== rowData.monthKey) {
              last = rowData.monthKey!;
            }
          });
        }
      });
    }, 100);
  }
  
  // Données filtrées et paginées pour l'affichage
  salesDataFiltred: any[] = [];
  
  // Pagination
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 0;
  totalPages: number = 1;
  
  // Filtre/recherche
  searchTerm: string = '';
  filterFields: string[] = [
    'saleRef',
    'designation',
    'famille',
    'faitePar',
    'origine'
  ];
  
  // Options pour le nombre d'éléments par page
  pageSizeOptions: number[] = [5, 10, 25, 50, 100];
  
  
  // Pour afficher les infos de pagination
  startIndex: number = 0;
  endIndex: number = 0;

  /**
   * Appliquer le filtre et la pagination
   */
  applyFilter(): void {
    if (this.searchTerm.trim() === '') {
      // Pas de filtre → tout afficher avec expanded restauré
      this.salesDataFiltred = this.salesData.map((s: any) => ({
        ...s,
        expanded: s.rowType === 'sale-ref-header' ? true : undefined
      }));
      return;
    }

    const term = this.searchTerm.toLowerCase().trim();
    const result: any[] = [];

    let currentMonthHeader: any = null;
    let monthHasResults = false;

    for (const row of this.salesData) {

      // ── Mémoriser l'en-tête de mois courant ─────────────────
      if (row.rowType === 'month-header') {
        currentMonthHeader = row;
        monthHasResults    = false;
        continue;
      }

      // ── Filtrer sur sale-ref-header ──────────────────────────
      if (row.rowType === 'sale-ref-header') {

        // Chercher dans saleRef et faitePar (niveau groupe)
        const refMatch =
          row.saleRef?.toLowerCase().includes(term) ||
          row.faitePar?.toLowerCase().includes(term);

        // Chercher dans les lignes détail
        const matchedLines = (row.lines ?? []).filter((line: any) =>
          this.filterFields.some((field: string) =>
            line[field]?.toString().toLowerCase().includes(term)
          )
        );

        const hasMatch = refMatch || matchedLines.length > 0;

        if (hasMatch) {
          // Ajouter l'en-tête de mois si pas encore ajouté
          if (currentMonthHeader && !monthHasResults) {
            result.push({ ...currentMonthHeader });
            monthHasResults = true;
          }

          // Ajouter le groupe avec les lignes filtrées
          result.push({
            ...row,
            expanded: true,
            // Si match sur la ref → garder toutes les lignes
            // Si match uniquement dans les lignes → garder seulement celles qui matchent
            lines: refMatch ? row.lines : matchedLines
          });
        }
      }
    }

    this.salesDataFiltred = result;
  }

  /**
   * Gérer la recherche
   */
  onSearch(): void {
    this.currentPage = 1; // Revenir à la première page
    this.applyFilter();
  }

  /**
   * Changer le nombre d'éléments par page
   */
  onPageSizeChange(): void {
    this.currentPage = 1; // Revenir à la première page
    this.applyFilter();
  }

  /**
   * Aller à une page spécifique
   */
  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.currentPage = page;
      this.applyFilter();
    }
  }

  /**
   * Aller à la page précédente
   */
  previousPageList(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.applyFilter();
    }
  }

  /**
   * Aller à la page suivante
   */
  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.applyFilter();
    }
  }

  /**
   * Obtenir les numéros de page à afficher (pour la pagination)
   */
  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxPagesToShow = 5;
    
    let startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = startPage + maxPagesToShow - 1;
    
    if (endPage > this.totalPages) {
      endPage = this.totalPages;
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  }

  /**
   * Réinitialiser les filtres
   */
  resetFilters(): void {
    this.searchTerm = '';
    this.currentPage = 1;
    this.itemsPerPage = 10;
    this.salesDataFiltred = this.salesData;
    this.applyFilter();
  }

  /**
   * Exporter en Excel (version simplifiée)
   */
  exportToExcel(): void {
    exportToExcelSimple(this.salesDataFiltred, this.selectedCustomer?.customer_rs);
  }

  /**
   * Convertir les données en CSV (pour l'export simple)
   */
  private convertToCSV(data: any[]): string {
    const headers = ['Ref Vente', 'Désignation', 'Famille', 'Prix unitaire', 'Quantité', 'Total HT', 'TVA', 'Total TTC', 'Faite par', 'Origine'];
    
    const rows = data.map(item => [
      item.saleRef || '',
      item.designation || '',
      item.famille || '',
      item.prixUnitaire || '',
      item.quantite || '',
      item.totalHt || '',
      item.tva || '',
      item.totalTtc || '',
      item.faitePar || '',
      item.origine || ''
    ]);
    
    const csvRows = [
      headers.join(','),
      ...rows.map(row => row.join(','))
    ];
    
    return csvRows.join('\n');
  }

  /**
   * Télécharger un fichier CSV
   */
  private downloadCSV(content: string, filename: string): void {
    const blob = new Blob([content], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }


  //#endregion
}
